var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4421 13.9242L23.9087 16.8576C24.1087 17.2659 24.6421 17.6576 25.0921 17.7326L27.7504 18.1742C29.4504 18.4576 29.8504 19.6909 28.6254 20.9076L26.5587 22.9742C26.2087 23.3242 26.0171 23.9992 26.1254 24.4826L26.7171 27.0409C27.1837 29.0659 26.1087 29.8492 24.3171 28.7909L21.8254 27.3159C21.3754 27.0492 20.6337 27.0492 20.1754 27.3159L17.6837 28.7909C15.9004 29.8492 14.8171 29.0576 15.2837 27.0409L15.8754 24.4826C15.9837 23.9992 15.7921 23.3242 15.4421 22.9742L13.3754 20.9076C12.1587 19.6909 12.5504 18.4576 14.2504 18.1742L16.9087 17.7326C17.3504 17.6576 17.8837 17.2659 18.0837 16.8576L19.5504 13.9242C20.3504 12.3326 21.6504 12.3326 22.4421 13.9242Z",
    stroke: "#52848B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 22,
    r: 19.5,
    stroke: "#456B71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.6175ebe3705991862f2b6e7e0b5d3dfe.svg";
export { ForwardRef as ReactComponent };